import React from 'react';
import { motion } from 'framer-motion';
import { Download, Footprints, Moon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    icon: Download,
    title: 'Descarga Inmediata',
    desc: 'Obtén el manual inmediatamente en tu celular o tablet tras la compra. Sin esperas.'
  }, {
    num: '02',
    icon: Footprints,
    title: "Aplica 'Cero Pasos'",
    desc: 'Mañana mismo, realiza los 3 movimientos antes de poner un pie en el suelo.'
  }, {
    num: '03',
    icon: Moon,
    title: 'Recuperación Nocturna',
    desc: 'Repite la técnica de alivio por la tarde para eliminar la fatiga acumulada del día.'
  }];
  return <section className="py-20 bg-white" data-id="element-102">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="text-center mb-16" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-105">
            Cómo funciona el proceso
          </h2>
          <p className="text-lg text-slate-600" data-id="element-106">
            Tres simples pasos para retomar el control de tus mañanas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-107">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-brand-100 z-0" data-id="element-108" />

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-109">
              <div className="w-24 h-24 bg-white rounded-full border-4 border-brand-50 shadow-soft flex items-center justify-center mb-6 relative" data-id="element-110">
                <step.icon className="w-10 h-10 text-brand-600" data-id="element-111" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent-500 text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md" data-id="element-112">
                  {step.num}
                </div>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-113">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-114">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}